import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useEffect } from "react";
import FormTextField from "../../../components/elements/FormTextField";
import { CashModel } from "../../../data/models/cash/CashModel";
import { useFormWithNavigation } from "../../hooks/useFormWithNavigation";

interface Props {
  open: boolean;
  onClose: () => void;
  initialValue?: CashModel;
  onSave: (
    data: Omit<CashModel, "id"> | Partial<Omit<CashModel, "id">>
  ) => Promise<void> | void;
  loading: boolean;
}

export default function CreateEditCashDialog({
  open,
  onClose,
  initialValue,
  onSave,
  loading,
}: Props) {
  const initial: Omit<CashModel, "id" | "status"> = {
    name: "",
    // status: CashStatusEnum.CLOSING,
  };

  const validate = (
    field: keyof typeof initial,
    value: any,
    form: typeof initial
  ) => {
    if (["name"].includes(field) && !String(value).trim()) {
      return "Campo obligatorio";
    }

    return "";
  };

  const {
    form,
    setForm,
    errors,
    refs,
    handleChange,
    handleEnter,
    validateAll,
  } = useFormWithNavigation(initial, validate, { autofocus: true });

  useEffect(() => {
    if (open && !initialValue) {
      setForm(initial);
      setTimeout(() => {
        const firstKey = Object.keys(refs)[0] as keyof typeof initial;
        refs[firstKey]?.current?.focus();
      }, 50);
    }
  }, [open, initialValue]);

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!validateAll()) return;
    await onSave(form);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{initialValue ? "Editar caja" : "Nueva caja"}</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent>
          <FormTextField
            label="Nombre de la caja"
            field="name"
            form={form}
            errors={errors}
            refs={refs}
            onChange={handleChange("name", (v) => v.toUpperCase())}
            onKeyDown={handleEnter("name")}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button variant="contained" type="submit" loading={loading}>
            {initialValue ? "Guardar cambios" : "Crear caja"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
